import HelperMixin from '../../Shared/HelperMixin.vue';
import PaginationHelper from '../../Shared/PaginationHelper.vue';

export default {
    name: 'RotationTransfers',
    mixins: [HelperMixin],
    components: { PaginationHelper },

    async created() {
        await this.CheckLoginStatus();
        if (!this.loginDetails || !this.canViewRotationTransfersUi()) {
            this.logout();
            return;
        }
        this.GetInfo();
        if (this.$route && this.$route.query && this.$route.query.id) {
            this.openDetail({ id: Number(this.$route.query.id) });
        }
    },

    computed: {
        isMinistryUser() {
            return this.isMinistryStockAdminUi();
        },
        isFacilityUser() {
            return this.canReceiveRotationTransfersUi();
        }
    },

    data() {
        return {
            pageNo: 1,
            pageSize: 10,
            pages: 0,
            Search: '',
            statusFilter: 0,
            Info: [],
            detail: null,
            detailDialog: false,
            executeDialog: false,
            executeForm: {
                id: 0,
                note: ''
            }
        };
    },

    methods: {
        GetInfo(pageNo) {
            this.pageNo = pageNo || 1;
            this.$blockUI.Start();
            this.$http.GetRotationTransfers(this.pageNo, this.pageSize, this.Search, this.statusFilter)
                .then((response) => {
                    this.$blockUI.Stop();
                    this.Info = response.data.info || [];
                    this.pages = response.data.count || 0;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                    this.Info = [];
                    this.pages = 0;
                });
        },
        openDetail(item) {
            this.$blockUI.Start();
            this.$http.GetRotationTransfer(item.id)
                .then((response) => {
                    this.$blockUI.Stop();
                    this.detail = response.data.info;
                    this.detailDialog = true;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                });
        },
        openExecute() {
            if (!this.detail) return;
            this.executeForm = {
                id: this.detail.id,
                note: ''
            };
            this.executeDialog = true;
        },
        submitExecute() {
            this.$blockUI.Start();
            this.$http.ExecuteRotationTransfer(this.executeForm)
                .then((response) => {
                    this.$blockUI.Stop();
                    this.$helper.ShowMessage('success', 'تم', response.data);
                    this.executeDialog = false;
                    this.detailDialog = false;
                    this.detail = null;
                    this.GetInfo(this.pageNo);
                })
                .catch((err) => {
                    this.$blockUI.Stop();
                    const msg = err.response && err.response.data ? err.response.data : 'خطأ';
                    this.$helper.ShowMessage('error', 'خطأ', msg);
                });
        },
        openVoucher(voucher) {
            this.openStockVoucher(voucher);
        }
    }
};
